(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-styles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-code')) {
    customElements.define('gift-code', class extends HTMLElement {
      connectedCallback() {
        const b = this.querySelector('[data-code]');
        if (b) b.addEventListener('click', () => {
          if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.code);
          b.classList.add('is-copied'); setTimeout(() => b.classList.remove('is-copied'), 1500);
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-product-timer-1"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mtOfferTimerBootV2) return;
    window.__mtOfferTimerBootV2 = true;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function paint(root, ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60
      };
      Object.keys(parts).forEach(function (key) {
        var el = root.querySelector('[data-' + key + ']');
        if (el) el.textContent = pad(parts[key]);
      });
    }

    function tick(root) {
      if (!root.isConnected) return false;
      var endUnix = parseInt(root.getAttribute('data-end-unix'), 10);
      if (!endUnix) return false;
      var diff = endUnix * 1000 - Date.now();
      if (diff <= 0) {
        paint(root, 0);
        root.hidden = true;
        return false;
      }
      root.hidden = false;
      paint(root, diff);
      return true;
    }

    function bind(root) {
      if (!root || root.getAttribute('data-timer-bound') === 'true') return;
      root.setAttribute('data-timer-bound', 'true');
      if (!root.getAttribute('data-end-unix')) return;
      if (!tick(root)) return;
      var id = window.setInterval(function () {
        if (!tick(root)) window.clearInterval(id);
      }, 1000);
    }

    function bindToggle(root) {
      var btn = root.querySelector('[data-offer-timer-toggle]');
      var panel = root.querySelector('[data-offer-timer-panel]');
      if (!btn || !panel || btn.getAttribute('data-toggle-bound') === 'true') return;
      btn.setAttribute('data-toggle-bound', 'true');
      var showLabel = 'Show offer details';
      var hideLabel = 'Hide offer details';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var hiddenLabel = btn.querySelector('.visually-hidden');
        if (hiddenLabel) hiddenLabel.textContent = open ? hideLabel : showLabel;
        panel.hidden = !open;
      });
    }

    function boot() {
      document.querySelectorAll('[data-offer-timer]').forEach(function (root) {
        bind(root);
        bindToggle(root);
      });
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mt-product-timer-2"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mtOfferTimerBootV2) return;
    window.__mtOfferTimerBootV2 = true;

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function paint(root, ms) {
      var total = Math.max(0, Math.floor(ms / 1000));
      var parts = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60
      };
      Object.keys(parts).forEach(function (key) {
        var el = root.querySelector('[data-' + key + ']');
        if (el) el.textContent = pad(parts[key]);
      });
    }

    function tick(root) {
      if (!root.isConnected) return false;
      var endUnix = parseInt(root.getAttribute('data-end-unix'), 10);
      if (!endUnix) return false;
      var diff = endUnix * 1000 - Date.now();
      if (diff <= 0) {
        paint(root, 0);
        root.hidden = true;
        return false;
      }
      root.hidden = false;
      paint(root, diff);
      return true;
    }

    function bind(root) {
      if (!root || root.getAttribute('data-timer-bound') === 'true') return;
      root.setAttribute('data-timer-bound', 'true');
      if (!root.getAttribute('data-end-unix')) return;
      if (!tick(root)) return;
      var id = window.setInterval(function () {
        if (!tick(root)) window.clearInterval(id);
      }, 1000);
    }

    function bindToggle(root) {
      var btn = root.querySelector('[data-offer-timer-toggle]');
      var panel = root.querySelector('[data-offer-timer-panel]');
      if (!btn || !panel || btn.getAttribute('data-toggle-bound') === 'true') return;
      btn.setAttribute('data-toggle-bound', 'true');
      var showLabel = 'Show offer details';
      var hideLabel = 'Hide offer details';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var hiddenLabel = btn.querySelector('.visually-hidden');
        if (hiddenLabel) hiddenLabel.textContent = open ? hideLabel : showLabel;
        panel.hidden = !open;
      });
    }

    function boot() {
      document.querySelectorAll('[data-offer-timer]').forEach(function (root) {
        bind(root);
        bindToggle(root);
      });
    }

    boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
